module.exports = __webpack_public_path__ + "img/facebookicon.56e52b5d.svg";